import { FormikProps, useFormikContext } from 'formik'

import { useState } from 'react'
import { useStyles } from './AzureCombinedFormSections.styles'
import { scrollspyTabs } from '@labrav/common'
import { useTheme } from '@mui/material'
import { MainTabsV2 } from '@labrav/react-components'
import { ScrollToFieldError } from '@labrav/common'
import { OfferDetails } from './OfferDetails/OfferDetails'
import { ContractDuration } from './OtherComponents/ContractDuration'
import { PaymentConfiguration } from './PaymentConfiguration/PaymentConfiguration'
import { Renewal } from './OtherComponents/Renewal'
import { EulaSection } from './EulaSection/EulaSection'
import { Product } from '../../../modules/productsListing/reducer'
import { MsftCombinedFormState } from '../../../modules/microsoftCombinedForm/reducer'
import { Plan } from './Plan/Plan'
import { useFlyOutProductsBasedOnSelectedCloud } from '../../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import { getIsErrorForAzureCombinedFormTab } from '../../PrivateOfferFormV2/AzureOffer/getIsErrorForMPPOOfferTab'

export const AzureCombinedFormSections = () => {
  const theme = useTheme()
  const offset = 260
  const { classes } = useStyles({ offset })
  const formikProps = useFormikContext<MsftCombinedFormState>()
  const [eulaErr, setEulaErr] = useState<string>('')
  const { products } = useFlyOutProductsBasedOnSelectedCloud()
  const selectedProductId = formikProps.values?.draftOffer?.labraProductId
  const product =
    products.find(product => product.productId === selectedProductId) ||
    ({} as Product)

  const combinedFormSectionsTabs = [
    {
      key: 'offer-details',
      label: 'Offer details',
      renderElement: (
        <div
          id={'offer-details'}
          data-testid={'offer-details'}
          className={classes.scrollTopMargin}
        >
          <OfferDetails disabled={false} />
          <PaymentConfiguration disabled={true} />
          <ContractDuration />
        </div>
      ),
      isError: getIsErrorForAzureCombinedFormTab({
        tabName: 'offer-details',
        formikValues: formikProps as unknown as FormikProps<
          Record<string, unknown>
        >,
      }),
    },
    {
      key: 'offer-pricing',
      label: 'Pricing',
      renderElement: (
        <div
          id={'offer-pricing'}
          data-testid={'offer-pricing'}
          className={classes.scrollTopMargin}
        >
          <Plan product={product} />
        </div>
      ),
      isError: getIsErrorForAzureCombinedFormTab({
        tabName: 'offer-pricing',
        formikValues: formikProps as unknown as FormikProps<
          Record<string, unknown>
        >,
      }),
    },
    {
      key: 'offer-other',
      label: 'Other',
      renderElement: (
        <div
          id={'offer-other'}
          data-testid={'offer-other'}
          className={classes.scrollTopMargin}
        >
          <Renewal />
          <EulaSection
            eulaErr={eulaErr}
            setEulaErr={setEulaErr}
            disabled={false}
          />
        </div>
      ),
      isError: getIsErrorForAzureCombinedFormTab({
        tabName: 'offer-other',
        formikValues: formikProps as unknown as FormikProps<
          Record<string, unknown>
        >,
        eulaErr,
      }),
    },
  ]
  const { activeTabInex, scrollToSection } = scrollspyTabs({
    tabs: combinedFormSectionsTabs,
    offset: offset,
  })

  return (
    <div className={classes.root}>
      <ScrollToFieldError customErrorFields={eulaErr ? ['eulaFile'] : []} />
      <MainTabsV2
        activeTabIndex={activeTabInex}
        onChange={scrollToSection}
        tabs={combinedFormSectionsTabs}
        backGroundColor={theme.palette.textBackground.light}
        tabPosition="sticky"
        tabTop={'0px'}
      />
      {combinedFormSectionsTabs.map(tabItem => tabItem.renderElement)}
    </div>
  )
}
